export const CHANGE_DATE = 'CHANGE_DATE';
export const CALENDAR_CHANGE = 'CALENDAR_CHANGE';
export const FETCH_SESSIONS = 'FETCH_SESSIONS';
export const FETCH_SESSIONS_FAIL = 'FETCH_SESSIONS_FAIL';
export const FETCH_SESSIONS_SUCCESS = 'FETCH_SESSIONS_SUCCESS';
export const GET_SESSIONS = 'GET_SESSIONS';
export const GET_SESSIONS_FAIL = 'GET_SESSIONS_FAIL';
export const GET_SESSIONS_SUCCESS = 'GET_SESSIONS_SUCCESS';
export const MORE_DAYS = 'MORE_DAYS';
export const PRE_RENDER_DATA = 'PRE_RENDER_DATA';
export const SET_FACILITY = 'SET_FACILITY';
export const SET_GROUP_BY = 'SET_GROUP_BY';

export const FetchSessions = () => ({
  type: FETCH_SESSIONS,
});

export const GetSessions = (date = new Date()) => ({
  date,
  type: GET_SESSIONS,
});
